<template>
  <d-container fluid class="main-content-container p-4">
    <d-card title="Exporter les comptes" class="card-small">
      <d-card-header>
        <h3 class="text-center">Exporter les services marchands</h3>
      </d-card-header>
      <d-card-body>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="select" label="Format d'export" :options="formatOptions" v-model="format"/>
            <c-input type="select" label="Séparateur" :options="delimiterOptions" v-model="delimiter"/>
            <c-input type="number" label="Nombre max de compte(s)" placeholder="Laissez vide pour tout exporter"
                     v-model="limit" :state="limitState">
              Veuillez saisir un nombre positif ou laissez vide
            </c-input>
          </d-col>
          <d-col class="ml-2">
            <c-input
              type="multiselect" label="Colonnes à exporter" placeholder="Sélectionnez les colonnes à exporter"
              :options="columnsOptions" v-model="columns" :state="columnsState"
            >
              Veuillez sélectionner les colonnes à exporter
            </c-input>
            <c-input type="select" label="Activation" :options="activationOptions" v-model="enabled"
                     :state="true">
              Veuillez sélectionner au moins un filtre
            </c-input>
            <d-row>
              <d-col>
                <c-input type="price" label="Solde min" v-model="minBalance" currency="XAF"/>
              </d-col>
              <d-col>
                <c-input type="price" label="Solde max" v-model="maxBalance" currency="XAF"/>
              </d-col>
            </d-row>
          </d-col>
        </d-form-row>
      </d-card-body>
      <d-card-footer>
        <d-input-group class="justify-content-center">
          <c-input
            type="filename" class="w-50" placeholder="Nom du fichier"
            v-model="filename" :extension="extension" :state="filenameState"
          >
            Veuillez saisir un nom de fichier valide
          </c-input>
          <c-button-spinner class="inline-btn ml-1" variant="primary" :fetching="fetching" @click="onDownload">
            <template slot="icon"><i class="fa fa-download"></i></template>
            Télécharger
          </c-button-spinner>
          <vue-json-csv
            ref="csv"
            :data="services" :fields="csvFields" :labels="csvLabels"
            :name="csvFilename" :delimiter="delimiter"
          >
            <span></span>
          </vue-json-csv>
        </d-input-group>
      </d-card-footer>
    </d-card>
  </d-container>
</template>

<script>
import VueJsonCsv from "vue-json-csv"
import {Api, DateFormatter, Regex, Toast} from "@/helpers"

export default {
  title: "Exporter les services marchands",
  components: {VueJsonCsv},
  data() {
    return {
      services: [],

      fetching: false,
      submitted: false,

      format: "CSV",
      delimiter: ";",
      limit: "",

      columns: [
        {text: "Service", value: "s_name"},
        {text: "Solde", value: "s_balance"},
        {text: "Actif", value: "s_enabled"},
        {text: "Email de notification", value: "s_notify_email"},
        {text: "Propriétaire", value: "u_name"},
        {text: "Email du propriétaire", value: "u_email"},
        {text: "Tél. du propriétaire", value: "u_phone_number"},
        {text: "Orange Money", value: "CM_OM"},
        {text: "MTN Mobile Money", value: "CM_MOMO"},
        {text: "Carte Bancaire", value: "STRIPE"},
        {text: "My-CoolPay", value: "MCP"},
      ],
      enabled: null,
      minBalance: null,
      maxBalance: null,

      filename: "My-CoolPay_Services_" + DateFormatter.forFilename(),
    }
  },
  computed: {
    csvFields() {
      return this.columns.map(c => c.value)
    },
    csvLabels() {
      return Object.fromEntries(this.columns.map(c => [c.value, c.text]))
    },
    csvFilename() {
      return this.filename + this.extension
    },
    columnsOptions() {
      return [
        {text: "Service", value: "s_name"},
        {text: "Solde", value: "s_balance"},
        {text: "Actif", value: "s_enabled"},
        {text: "Email de notification", value: "s_notify_email"},
        {text: "Propriétaire", value: "u_name"},
        {text: "Email du propriétaire", value: "u_email"},
        {text: "Tél. du propriétaire", value: "u_phone_number"},
        {text: "Orange Money", value: "CM_OM"},
        {text: "MTN Mobile Money", value: "CM_MOMO"},
        {text: "Carte Bancaire", value: "STRIPE"},
        {text: "My-CoolPay", value: "MCP"},
      ]
    },
    activationOptions() {
      return [
        {text: "Tous les services", value: null},
        {text: "Activés", value: true},
        {text: "Non activés", value: false},
      ]
    },
    formatOptions() {
      return [{text: "CSV", value: "CSV"}]
    },
    delimiterOptions() {
      return [{text: ";", value: ";"}, {text: ",", value: ","}]
    },
    extension() {
      return ".csv"
    },
    limitState() {
      return !this.submitted || Regex.isEmptyOrStrictPositiveInteger(this.limit)
    },
    columnsState() {
      return !this.submitted || this.columns.length > 0
    },
    minBalanceState() {
      return !this.submitted || Regex.isEmptyOrStrictPositiveInteger(this.minBalance)
    },
    maxBalanceState() {
      return !this.submitted || Regex.isEmptyOrStrictPositiveInteger(this.maxBalance)
    },
    filenameState() {
      return !this.submitted || Regex.isValidFilename(this.filename)
    },
  },
  methods: {
    isFormValid() {
      return this.limitState && this.columnsState && this.minBalanceState && this.maxBalanceState && this.filenameState
    },
    onDownload() {
      this.submitted = true

      if (!this.isFormValid()) return

      this.fetching = true
      Api.get("/service/export", {
        columns: this.csvFields,
        enabled: this.enabled,
        min_balance: this.minBalance || null,
        max_balance: this.maxBalance || null,
        limit: this.limit || null,
      })
        .then(res => {
          this.services = res.data.services
          if (!this.services.length)
            Toast.info("Aucun service trouvé")
          else {
            Toast.loading(`Génération du fichier ${this.format}...`)
            setTimeout(() => {
              Toast.loadingToast.goAway()
              this.$refs.csv.generate()
            }, 2000)
          }
        })
        .catch(err => this.error = err)
        .then(() => {
          this.fetching = false
          this.submitted = false
        })
    },
  },
}
</script>
